import { A11yModule } from "@angular/cdk/a11y";
import { BidiModule } from "@angular/cdk/bidi";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { UiDropdownModule } from "../dropdown/dropdown.module";
import { UiIconModule } from "../icon/icon.module";
import { UiMenuModule } from "../menu/menu.module";
import { UiTabAddButtonComponent } from "./components/tab-add-button/tab-add-button.component";
import { UiTabBodyComponent } from "./components/tab-body/tab-body.component";
import { UiTabCloseButtonComponent } from "./components/tab-close/tab-close-button.component";
import { UiTabColorIndicatorComponent } from "./components/tab-color-indicator/tab-color-indicator.component";
import { UiTabNavBarComponent } from "./components/tab-nav-bar/tab-nav-bar.component";
import { UiTabNavOperationComponent } from "./components/tab-nav-operation/tab-nav-operation.component";
import { UiTabSetComponent } from "./components/tabset/tabset.component";
import { UiTabLinkDirective, UiTabLinkTemplateDirective } from "./directives/tab-link.directive";
import { UiTabNavItemDirective } from "./directives/tab-nav-item.directive";
import { UiTabScrollListDirective } from "./directives/tab-scroll-list.directive";
import { UiTabDirective } from "./directives/tab.directive";
import { UiTabsInkBarDirective } from "./directives/tabs-ink-bar.directive";
import { UiTabComponent } from "./tab.component";

@NgModule({
  imports: [CommonModule, BidiModule, NzOutletModule, UiMenuModule, UiDropdownModule, UiIconModule, A11yModule],
  declarations: [
    UiTabSetComponent,
    UiTabComponent,
    UiTabNavBarComponent,
    UiTabNavItemDirective,
    UiTabsInkBarDirective,
    UiTabScrollListDirective,
    UiTabNavOperationComponent,
    UiTabAddButtonComponent,
    UiTabCloseButtonComponent,
    UiTabDirective,
    UiTabBodyComponent,
    UiTabLinkDirective,
    UiTabLinkTemplateDirective,
    UiTabColorIndicatorComponent,
  ],
  exports: [UiTabSetComponent, UiTabComponent],
})
export class UiTabModule {}
